/**
 * <h4>Customer configuration parameters</h4>
 *
 * An interface that shows the necessary data to start using the system
 *
 * If you do not know where to get the customer's symbol, please contact our technical support.
 */
export interface ConfigParams {
    /** Customer host configuration. Host assigned to the customer */
    host: string;
    /** Customer symbol configuration. Unique customer identifier */
    customerSymbol: string;
    /** Optional cookie only for test in node **/
    cookie?:string
}

/**
 * <h4>Customer configuration class<h4/>
 *
 * You need to set variable `customerSymbol` and variable `host` to be able to use Quarticon recommendation frames.
 *
 * If you do not know where to get the customer's symbol, please contact our technical support.
 *
 * ```typescript
 * const customerConfiguration = new Config({customerSymbol: _CUSTOMER_SYMBOL_, host: _HOST_})
 * ```
 */
export class Config {
    private readonly host: string;
    private readonly customerSymbol: string;
    private readonly cookie: string;

    /**
     * @param configParams Customer configuration parameters
     * @returns Main configuration element
     */
    constructor(configParams: ConfigParams) {
        this.customerSymbol = configParams.customerSymbol
        this.host = configParams.host
        this.cookie = configParams.cookie
    }

    /** @ignore */
    getHost = (): string => {
        return this.host
    }
    /** @ignore */
    getCustomer = (): string => {
        return this.customerSymbol
    }
    /** @ignore */
    getBaseUrl = (): string => {
        return `qon.${this.host}`
    }

    /** @ignore */
    getCookie = (): string => {
        return this.cookie
    }

}
